import ActivityIndicator from 'react-spinners/BeatLoader'

const Spinner = () => <ActivityIndicator color='#4461D4' />

export default Spinner
